import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Analytics } from "@vercel/analytics/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const MiniButton = lazy(() => import("./components/MiniButton"));

const EXPERIMENT_MINI_BUTTON = true;

const isMiniMode =
  EXPERIMENT_MINI_BUTTON &&
  new URLSearchParams(window.location.search).get("mode") === "button";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <>
      {isMiniMode ? (
        <Suspense fallback={null}>
          <MiniButton />
        </Suspense>
      ) : (
        <App />
      )}
      <Analytics />
    </>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
